import {
	WeaAlertPage,
	WeaLocaleProvider,
} from 'ecCom';
import {
	Spin
} from 'antd';
const getLabel = WeaLocaleProvider.getLabel;

export default class AlertPage extends React.Component {
	render() {
		const {
			loading
		} = this.props;

		const style = {
			position: 'absolute',
			top: '50%',
			left: '50%',
			marginLeft: -16,
			marginTop: -16,
		}

		if (loading) {
			return (
				<div style={style}>
					<Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@t5atvz`} spinning={true} size='large'></Spin>
				</div>
			)
		} else {
			return (
				<div style={{height:'100%'}}>
	                <WeaAlertPage ecId={`${this && this.props && this.props.ecId || ''}_WeaAlertPage@vixc9z`}>
	                    <div style={{ color: '#000' }}>
	                        {getLabel(2012, '对不起，您暂时没有权限！')}
	                    </div>
	                </WeaAlertPage>
	            </div>
			)
		}
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/public/components/AlertPage.js